import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, BaseModelObject, ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"

// Model Objects

export class DistributionConfiguration extends ModelObject<DistributionConfiguration> {

    public version: number = 0;
    /**
    * Default stop minutes for new Outlets / Visits.
    * Not Negative
    */
    public defaultStopMinutes: number = 0;

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.version = jsonSerializedObject.version;
          this.defaultStopMinutes = jsonSerializedObject.defaultStopMinutes;
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.version = this.version;
        toRet.defaultStopMinutes = this.defaultStopMinutes;
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
            {field: "version", rule: (v: any) => v == null || v >= -9223372036854775808 || "Version is not greater than minimum allowed value: -9223372036854775808"},
            {field: "version", rule: (v: any) => v == null || v <= 9223372036854775807 || "Version is above maximum allowed value: 9223372036854775807"},
            {field: "defaultStopMinutes", rule: (v: any) => v == null || v >= 0 || "DefaultStopMinutes is not greater than minimum allowed value: 0"},
            {field: "defaultStopMinutes", rule: (v: any) => v == null || v <= 2147483647 || "DefaultStopMinutes is above maximum allowed value: 2147483647"},
    ];
}


export class DistributionConfigurationService extends ServiceBase {

  public async getDistributionConfiguration(tenantId: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<DistributionConfiguration> {
    const req = {
    tenantId:tenantId.toString(),
    };
    const extractor = (response:any) => new DistributionConfiguration(response.distributionConfiguration);;
    return this.makeJsonRequest("distributionConfiguration/v1/getDistributionConfiguration", req, false, extractor, opts);
  };

  public async updateDistributionConfiguration(tenantId: Guid, defaultStopMinutes: number | null, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<void> {
    const req = {
    tenantId:tenantId.toString(),
    defaultStopMinutes:defaultStopMinutes == null ? null : defaultStopMinutes,
    };
    const extractor = null;
    return this.makeJsonRequest("distributionConfiguration/v1/updateDistributionConfiguration", req, true, extractor, opts);
  };
}

export const distributionConfigurationService = new DistributionConfigurationService();